import React, { useEffect, useRef } from "react";
import landingvid from "./assets/landing.webm";

const Landing = ({ onComplete }) => {
    // 1. Create a reference for the video element
    const videoRef = useRef(null);

    useEffect(() => {
        const originalBodyOverflow = document.body.style.overflow;
        const originalHtmlOverflow = document.documentElement.style.overflow;

        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";

        const preventScroll = (e) => {
            e.preventDefault();
        };

        window.addEventListener("wheel", preventScroll, { passive: false });
        window.addEventListener("touchmove", preventScroll, { passive: false });

        // 2. iOS Autoplay Fix: Force muted and trigger play manually
        if (videoRef.current) {
            videoRef.current.defaultMuted = true;
            videoRef.current.muted = true;
            videoRef.current.play().catch((error) => {
                console.error("Autoplay prevented by browser:", error);
            });
        }

        return () => {
            document.body.style.overflow = originalBodyOverflow;
            document.documentElement.style.overflow = originalHtmlOverflow;
            window.removeEventListener("wheel", preventScroll);
            window.removeEventListener("touchmove", preventScroll);
        };
    }, []);

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "black",
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                touchAction: "none",
                overflow: "hidden",
            }}
        >
            <video
                ref={videoRef}
                src={landingvid}
                autoPlay
                muted
                playsInline
                onEnded={onComplete}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    pointerEvents: "none",
                    userSelect: "none",
                    WebkitUserSelect: "none",
                }}
            />
        </div>
    );
};

export default Landing;
